import React from "react"

function Sidebar() {
    return (
        <>
            <div className="icon-bar">
                <a href="https://github.com/Carlosbenitez" target="_blank" className="github"><i className="fa fa-github"></i></a>
                <a href="https://www.linkedin.com/in/carlos-j-benitez-a2869411a/" target="_blank" className="linkedin"><i className="fa fa-linkedin"></i></a>
                <a href="https://www.youtube.com/channel/UCuikal0_fCRekNXm93oFlhg" target="_blank" className="youtube"><i className="fa fa-youtube"></i></a>
            </div>
        </>
    )
}

export default Sidebar